module.exports = __webpack_public_path__ + "img/crosshairs.a24c975a.svg";